// Utility for handling user selected choices logic across different question types

/**
 * Get user selected choices for a question, handling correct/incorrect/random logic.
 * @param {Object} params
 * @param {Object} params.question - The question object
 * @param {Object} params.stat - The statistics/state object for the question
 * @param {Object} params.config - Config object for question type specifics
 * @returns {Object} { selectedOptions, extraState } - State to set in the component
 */
export function getUserSelectedChoices({ question, stat, config = {} }) {
  try {
    // 1. If user has selected choices, parse and return
    if (stat && stat.selected_choice) {
      const { selected_choice } = stat;
      const selectedOptions = JSON.parse(selected_choice);
      const { extractExtraState } = config;
      return {
        selectedOptions,
        extraState:
          typeof extractExtraState === 'function' ? extractExtraState(selectedOptions) : {},
      };
    }

    // 2. If correct answer to be filled in
    if (stat && stat.isSelectedChoice === 1) {
      const { getCorrectOptions, extractExtraState } = config;
      if (getCorrectOptions) {
        const selectedOptions = getCorrectOptions(question);
        return {
          selectedOptions,
          extraState:
            typeof extractExtraState === 'function' ? extractExtraState(selectedOptions) : {},
        };
      }
    }

    // 3. If incorrect answer to be filled randomly
    if (stat && stat.isSelectedChoice === 0) {
      const { getWrongOptions, extractExtraState } = config;
      if (getWrongOptions) {
        const selectedOptions = getWrongOptions(question);
        return {
          selectedOptions,
          extraState:
            typeof extractExtraState === 'function' ? extractExtraState(selectedOptions) : {},
        };
      }
    }
  } catch (err) {
    // Swallow error silently to avoid linter issues
  }
  // Default: return empty
  return { selectedOptions: {}, extraState: {} };
}



// WEBPACK FOOTER //
// ./src/Components-2025/IR/utils/questionUtils.js